module.exports = __webpack_public_path__ + "static/media/1011115.b6fed1b3.jpg";